import { render } from "./Espanol.vue?vue&type=template&id=792e3b4d"
import script from "./Espanol.vue?vue&type=script&lang=js"
export * from "./Espanol.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__